import React, { useEffect, useState } from "react";
import { Box, Container } from "@material-ui/core";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import useStyles from "./styles";
import { useHistory, Link } from "react-router-dom";
import Logo from "../../../assets/images/ialign-logo.png";
import { get } from "lodash";
import { Auth } from "aws-amplify";

const ErrorPage = ({ errorCode, url }) => {
  const classes = useStyles();
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState({});

  useEffect(() => {
    generateErrorMessage();
  }, [errorCode]);

  useEffect(() => {
    if (errorCode === "401") {
      localStorage.setItem(
        "loggedInRememberPath",
        get(history, "location.pathname")
      );
      Auth.signOut();
      // const timer = setTimeout(() => {
      //   redirectToLogin();
      // }, 1000);
    }
  }, []);

  const generateErrorMessage = () => {
    switch (errorCode) {
      case "401": {
        setErrorMessage({
          errorCode,
          errorType: "Authorization Required",
          errorMessage: "Your authorization to access this URL is not verified",
        });
        break;
      }
      case "404": {
        setErrorMessage({
          errorCode,
          errorType: "Page Not Found",
          errorMessage: "The page you are looking for is not found",
        });
        break;
      }
      case "403": {
        setErrorMessage({
          errorCode,
          errorType: "Forbidden Access",
          errorMessage: "You don't have permission to access this URL",
        });
        break;
      }
      case "408": {
        setErrorMessage({
          errorCode,
          errorType: "Request Time-out",
          errorMessage: "Your browser didn't send a complete request in time",
        });
        break;
      }
      default: {
        setErrorMessage({
          errorType: "No Internet",
          errorMessage: "Check your internet connection and try again",
        });
        break;
      }
    }
  };

  const redirectToLogin = () => {
    history.push("/");
  };

  return (
    <Box className={classes.root}>
      <header>
        <Container maxWidth="xl">
          <Box display="flex" justifyContent="flex-start">
            <Link
              to={"/"}
              style={{ textDecoration: "none", cursor: "pointer" }}
            >
              <img src={Logo} alt="ialign logo" />
            </Link>
          </Box>
        </Container>
      </header>
      <Box
        className={classes.content}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <h1>
          <ReportProblemOutlinedIcon />
          {get(errorMessage, "errorCode", "")}{" "}
          {get(errorMessage, "errorType", "")}
        </h1>
        <h2>{get(errorMessage, "errorMessage", "")}</h2>
        <Link to={url} style={{ textDecoration: "none", cursor: "pointer" }}>
          {/* <h2>(Link)</h2> */}
        </Link>
        {errorCode === "401" ? (
          <Link
            to={"/"}
            style={{ textDecoration: "none", cursor: "pointer" }}
            data-testid="linkid"
            onClick={redirectToLogin}
          >
            Please login in to view this content
          </Link>
        ) : errorCode === "403" ? (
          "Please reach out to your company admin. "
        ) : (
          ""
        )}
      </Box>
      <Box className={classes.ErrorPageBottomBg}></Box>
    </Box>
  );
};

export default ErrorPage;
